import * as React from 'react';

const LogoHeader = () => {
    return(
        <div className="sid-header__logo">
            <img src="logo.png" alt="vineyard vines"/>
        </div>
    );
}

export const LogoHeaderComponent = LogoHeader;